<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90%', maxWidth: '900px' }"
  [closable]="!isLoading"
  (onHide)="onHide()"
  headerStyleClass="p-4 md:p-6"
  contentStyleClass="p-4 md:p-6"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3">
      <div
        class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-50 text-primary-500"
      >
        <app-greentripper-pin-icon
          styleClass="w-6 h-6"
        ></app-greentripper-pin-icon>
      </div>
      <div class="flex flex-col">
        <span class="text-xl font-semibold text-greyscale-900">
          {{ titleKey() | transloco }}
        </span>
        <span class="text-sm text-greyscale-600">
          {{ subtitleKey() | transloco }}
        </span>
      </div>
    </div>
  </ng-template>

  <div class="space-y-6">
    <!-- Résumé du parcours : même langage visuel que la page Prise en main -->
    <app-journey-header [compact]="true" />
    <app-journey-next-step [showCta]="false" />

    <!-- Contrôles -->
    <div
      class="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center"
    >
      <!-- Checkbox "Ne plus montrer" -->
      <div class="flex items-center gap-2">
        <p-checkbox
          [(ngModel)]="dontShowAgain"
          [binary]="true"
          inputId="dontShowAgainCheckbox"
          [disabled]="isLoading"
        >
        </p-checkbox>
        <label
          for="dontShowAgainCheckbox"
          class="cursor-pointer text-paragraph-s-reg transition-colors"
          [class.text-greyscale-400]="isLoading"
          [class.text-greyscale-700]="!isLoading"
        >
          {{ "help.onboarding.journey.popup.dontShowAgain" | transloco }}
        </label>
        <i
          class="pi pi-info-circle cursor-help text-sm text-greyscale-500"
          [pTooltip]="'help.onboarding.journey.popup.tooltip' | transloco"
          tooltipPosition="top"
          [tooltipOptions]="{ showDelay: 300, hideDelay: 200 }"
        >
        </i>
      </div>

      <!-- Boutons d'action -->
      <div class="flex w-full gap-3 sm:w-auto">
        <p-button
          [label]="ctaKey() | transloco"
          icon="pi pi-arrow-right"
          [loading]="isLoading"
          [disabled]="isLoading"
          (onClick)="onResumeJourney()"
          class="flex-1 sm:flex-none"
          styleClass="bg-primary-600 border-primary-600 text-white hover:bg-primary-700 hover:border-primary-700 active:bg-primary-800 active:border-primary-800 focus:ring-2 focus:ring-primary-300 focus:ring-offset-2"
        >
        </p-button>
      </div>
    </div>
  </div>
</p-dialog>
